import { render } from "./modal-similar.vue?vue&type=template&id=14be1956"
import script from "./modal-similar.vue?vue&type=script&lang=js"
export * from "./modal-similar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__